import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setPageSubType: YJSChangeHandler<DatabaseChangeType.SET_PAGE_SUB_TYPE> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.pageSubType = change.pageSubType;
  });
};
